import { Divider, Select } from 'antd';
import { UseTicketListParams, useUpdateTodoMutation } from 'hooks/business/chat/useTicketMutations';
import { useStatusLabel } from 'views/Todo/hooks/useLabel';
import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';
import { useTodoSubStatus } from 'views/Conversation/Sider/ToDoBundle/hook';
import { useTranslate } from '@tolgee/react';
import { css } from '@emotion/css';
import {
  isTodoCompleted,
  isTodoUnclaimed,
} from 'views/Conversation/Sider/ToDoBundle/useResultForm';

interface StatusProps {
  id: string;
  taskId: number;
  todoStatus: Todo.Status;
  listParams: UseTicketListParams | null;
  type: Todo.Type;
  subStatus?: string;
}

interface SubStatusProps {
  id: string;
  taskId: number;
  todoStatus: Todo.Status;
  value?: string;
  listParams: UseTicketListParams | null;
}

const SubStatus = (props: SubStatusProps) => {
  const { id, taskId, todoStatus, value, listParams } = props;

  const { t } = useTranslate();

  const { data } = useQuery({
    ...queries.tickets.statusList(taskId),
  });

  const subStatus = useTodoSubStatus(data || [], todoStatus);

  const { mutate: updateTodo } = useUpdateTodoMutation(listParams);

  const handleChange = (value: string) => {
    updateTodo({ id, subStatus: value || undefined });
  };

  if (subStatus.length === 0) {
    return null;
  }

  return (
    <>
      <Divider type="vertical" className="!mx-2" />
      <Select
        value={value || undefined}
        onChange={handleChange}
        dropdownMatchSelectWidth={false}
        bordered={false}
        placeholder={t('请选择子状态')}
        allowClear
      >
        {subStatus.map((each) => {
          return (
            <Select.Option key={each.subStatus} value={each.subStatus}>
              {each.subStatusLabel}
            </Select.Option>
          );
        })}
      </Select>
    </>
  );
};

export const Status = (props: StatusProps) => {
  const { id, taskId, todoStatus, listParams, subStatus } = props;
  const { getStatusLabel } = useStatusLabel();
  const { mutate: updateTodo } = useUpdateTodoMutation(listParams);
  const { t } = useTranslate();

  const handleChange = (value: Todo.Status) => {
    if (value === todoStatus) return;
    updateTodo({ id, todoStatus: value });
  };

  if (isTodoCompleted(todoStatus)) {
    // 待认领或已完成
    return <div className="text-[#232426]">{getStatusLabel(todoStatus)}</div>;
  }

  return (
    <div className="flex items-center">
      <Select
        value={isTodoUnclaimed(todoStatus) ? t('todo.待认领') : todoStatus}
        onChange={(value) => {
          handleChange(value as Todo.Status);
        }}
        bordered={false}
        className={selectCls}
      >
        <Select.Option value={2}>{getStatusLabel(2)}</Select.Option>
        <Select.Option value={4}>{getStatusLabel(4)}</Select.Option>
      </Select>
      <SubStatus
        id={id}
        taskId={taskId}
        todoStatus={todoStatus}
        value={subStatus}
        listParams={listParams}
      />
    </div>
  );
};

const selectCls = css`
  & > .ant-select-selector {
    padding-left: 0 !important;
  }
`;
